export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            关于棒棒TV
          </h2>

          <div className="mt-8 md:mt-10 bg-background-100 rounded-2xl p-6 md:p-10">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100">
              <i className="ri-play-circle-line text-3xl text-primary-500"></i>
            </div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
              棒棒TV是一个专注于高品质影视内容的在线观看平台。我们致力于为观众提供最新最全的电视剧全集和电影大全，涵盖国产剧、韩剧、美剧、日剧、动漫及热门综艺。平台所有内容均支持高清播放，智能加速技术确保流畅不卡顿。每日更新热播剧集和最新电影，无需注册即可免费在线观看。棒棒TV，让好剧触手可及。
            </p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line text-accent-500"></i> 安全可靠
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-flashlight-line text-accent-500"></i> 极速加载
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-user-smile-line text-accent-500"></i> 千万用户信赖
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}